import React, { useState } from "react";
import "./TracerMain.css";
import { Container } from "react-bootstrap";
import TracerProgress from "../../Component/Sidebar/TracerProgress";

import PortalConsole from "../../images/portalConsole.png";
import TracerSidebar from "../../Component/Sidebar/TracerSidebar";
import TracerNavbar from "../../Component/Navbar/TracerNavbar";
import Footer from "../../Component/Footer/Footer";
// import PotalConsoleInput from '../../Component/Sidebar/PortalConsoleInput';
const PortalConsolMain = () => {
  const [isActive, setActive] = useState(false);
  const toggleClass = () => {
    setActive(!isActive);
  };
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          <TracerSidebar handleClick={toggleClass} isActive={isActive} />
        </div>
        <div className="main w-100">
          <TracerNavbar isActive={isActive}/>
          <Container>
            <div className="head-select">
              <TracerProgress done={30} />

              <div className="main-select">
                <div className="portal-body">
                  <div className="console-text">
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>{" "}
                    <p>
                      Initialized empty Git repository in D:/company
                      project/custom project/card/profile/.git/
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
      {/* {openModel && <Model closeModel={setOpenModel}/>}
{openModelTest &&   <ModelTest closeModelTest={setOpenModelTest} />} */}
    </>
  );
};

export default PortalConsolMain;
